import jquery from 'jquery';
import $ from 'jquery';
import gsap from 'gsap';
import Swiper from 'swiper';

import Page from './page';
import Bar from './slide-bar'

import store from '../base/store';
import { hamburgers } from './hamburger-array';
import { calcolaAppartenenza, btnFade } from './utils';


class Slider {
    constructor() {
        const slides = Array.from(document.querySelectorAll('.swiper-slide'));
        this.currentIndex = 0;
        this.nextIndex = null;
        this.btnSlideNext = $('#arrow-btn-example');
        this.swiper = null;
        this.bar = null;
        this.transX = null;

        slides.forEach((el, i) => {
            if (i === 0) {
                el.setAttribute('data-animated', 'true');
            } else {
                el.setAttribute('data-animated', 'false');
            }
        });
    }

    init() {
        this.page = new Page({ slider: swiper, refer: this });
        this.page.init();
        this.bar = new Bar();
        this.bar.init();

        let swiper = this.swiper = new Swiper('#swiper-container', {
            slidesPerView: 'auto',
            speed: 1500,
            grabCursor: true,
            simulateTouch: true,
            shortSwipes: false,
            longSwipesRatio: 0.1,
            longSwipesMs: 10,
            centeredSlides: true,
            keyboardControl: true,
            mousewheelControl: true,
            onInit: () => {
                this.animate();
            },
            onSlideNextStart: () => {
                this.bar.increment();
            },
            onSlidePrevStart: () => {
                this.bar.decrement();
            }
        });

        this.bindEvents();
    }

    bindEvents() {
        this.swiper.on('onTransitionStart', () => {
            const slide = document.querySelector('.swiper-slide-active');

            if (slide.getAttribute('data-animated') === 'false') {
                this.animate();
            }
        });

        this.btnSlideNext.off('click').on('click',() => {
            this.swiper.slideNext();
        });

        $('.cont_burger').on( 'click', event => this.openPage(event));
    }

    bindEventPage() {

        $('.arrow-burger-prev').on('click', () => this.changePage('prev'));
        $('.arrow-burger-next').on('click', () => this.changePage('next'));

        $('#close-hamburger').off('click').on('click', () => {
            this.page.closeMask();
            this.swiper.unlockSwipes();
        });

    }

    unbindEventPage() {

        $('.arrow-burger-prev').off('click');
        $('.arrow-burger-next').off('click');
        $('#close-hamburger').off('click');

    }

    restartPages() {
        this.currentIndex = 0;
        this.page.changePage(this.currentIndex, 'right');
        this.swiper.slideTo(0);
        this.bar.reset('reset');
    }

    endPages() {
        const translate = $(window).width() - 130;
        this.currentIndex = hamburgers.length - 1;
        this.page.changePage(this.currentIndex, 'left');
        this.swiper.slideTo(5);
        this.bar.reset('end');
    }

    changePage(direction) {
        if (store.isAnimating) {
            return;
        }
        store.isAnimating = true;

        if (direction === 'next') {

            if ( this.currentIndex < hamburgers.length - 1 ) {
                let appId = this.currentIndex = this.currentIndex + 1;
                this.page.changePage(this.currentIndex, 'right');
                this.swiper.slideTo(calcolaAppartenenza(appId));
            } else {
                this.restartPages()
            }

        } else {
            if ( this.currentIndex > 0 ) {
                let appId = this.currentIndex = this.currentIndex - 1;
                this.page.changePage(this.currentIndex, 'left');
                this.swiper.slideTo(calcolaAppartenenza(appId));
            } else {
                this.endPages()
            }
        }
    }

    openPage(event) {
        const id = this.currentIndex = parseInt(event.currentTarget.getAttribute('data-id'));
        const $cont = $(event.currentTarget);

        this.swiper.unlockSwipes();
        this.page.expandMask($cont, id);

    }

    animate() {
        const slide = document.querySelector('.swiper-slide-active');

        slide.setAttribute('data-animated','true');

        this.$textImage = $(slide).find('.text-title-burger');
        this.$lineImage = $(slide).find('.linea-number-img');
        this.$contNumbe = $(slide).find('.cont-number');
        this.$numberImg = $(slide).find('.number-img');
        this.$line1Text = $(slide).find('.line1-text');
        this.$line2Text = $(slide).find('.line2-text');
        this.$hideImage = $(slide).find('.black-cover-img');

        if(!$( this.$hideImage ).hasClass( 'animated' )){
            this.$hideImage.addClass('black-cover-img--animated');
        }

        let enterTl = new TimelineMax({
            onComplete: () => {
                $('#about-btn').removeClass('first-animation-btn');
            }
        });

        enterTl.to(this.$hideImage, 1.4, {
            left: '100%',
            ease: Power3.easeInOut,
            delay: 0.1
        }).to(this.$line1Text, 0.6, {
            top: 0,
            ease: Power3.easeInOut
        }, 0.4).to(this.$line2Text, 0.6, {
            top: 0,
            ease: Power3.easeInOut
        }, 0.6).to(this.$lineImage, 1, {
            right: 0,
            ease: Power3.easeInOut
        }, 0.1).to(this.$contNumbe, 1.1, {
            left: 0,
            ease: Power3.easeInOut
        }, 0.1).to(this.$numberImg, 1.1, {
            left: 0,
            ease: Power3.easeInOut
        }, 0.2).to('.slide-bar', 0.6, {
            bottom: 0,
            ease: Power3.easeInOut
        }, 0.1).to('.first-animation-btn .line-btn', 0.6, {
            width: '100%',
            ease: Power3.easeInOut
        }, 0.1).to('.first-animation-btn p', 0.6, {
            top: 0,
            ease: Power3.easeInOut
        }, 0.8);
    }

}

export default Slider;



/** WEBPACK FOOTER **
 ** ./components/slider.js
 **/